export default "__VITE_ASSET__HmXPWhwM__"